import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Visitor } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Visitor";
export const VisitorService = {
	endpoint,
	createSingle: async (data: Visitor) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	sendEmailNotification: async (id: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/SendEmailNotification/${id}`, {headers: {"Content-Type": "application/json"}, method: "POST"}),
	sendSMSNotification: async (id: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/SendSMSNotification/${id}`, {headers: {"Content-Type": "application/json"}, method: "POST"}),
	updateSingleById: async (id: number, data: Visitor) => await Service.updateSingleById(endpoint, id, data),
}